<template>
  <v-form ref="loginForm" v-model="formValid">
    <v-text-field
      :label="usernameLabel"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :error-messages="emailError ? [emailError] : undefined"
      :style="styles['username']"
      :class="classes['username']"
      :rules="[rules.required, rules.email]"
      @keydown="handleKeyDown"
      v-model="localUsername"
    ></v-text-field>
    <v-text-field
      :label="passwordLabel"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :rules="[rules.required]"
      :style="styles['password']"
      :error-messages="passwordError ? [passwordError] : undefined"
      :type="passwordVisible ? 'text' : 'password'"
      :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
      @keydown="handleKeyDown"
      @click:append="passwordVisible = !passwordVisible"
      v-model="localPassword"
    ></v-text-field>
    <div 
      v-if="createAccountButton" 
      class="pa-3 text-center"
      style="font-size: 10pt"
      :class="classes['createAccountButton']" 
      :style="styles['createAccountButton']"
    >
      <slot name="createAccountButton" v-bind:emit="emit">
        {{$vuetify.lang.t('$vuetify.not_have_an_account')}} <a v-on:click.prevent="emit('create-account')">{{$vuetify.lang.t('$vuetify.create_one')}}</a>
      </slot>
    </div>
    <div 
      class="d-flex" 
      :class="{
        'justify-center': loginButtonAlignment == 'center', 
        'justify-end': loginButtonAlignment == 'right', 
        'justify-start': loginButtonAlignment == 'left'
      }"
      >
      <v-btn
        :color="loginButtonColor ? loginButtonColor : color"
        :block="loginButtonBlock"
        :outlined="loginButtonOutlined"
        :loading="loading"
        :style="styles['password']"
        :disabled="disabled || (disabledWhenNotValid && !formValid)"
        @click="emit('login-click', localUsername, localPassword)"
      >Login</v-btn>
    </div>
  </v-form>
</template>

<script>
import emittable from '../../../mixins/emittable'
import formValidable from '../../../mixins/formValidable'

import {
  VForm,
  VTextField,
  VBtn
} from 'vuetify/lib'

export default {
  name: "LoginForm",
  components: {
    VForm,
    VTextField,
    VBtn
  },
  mixins: [emittable, formValidable],
  data: function() {
    return {
      localPassword: this.password,
      localUsername: this.username,
      passwordVisible: false,
      formValid: undefined
    }
  },
  mounted() {
    if(this.bus) {
      this.bus.on('reset-validation', function() {
        this.$refs.loginForm.resetValidation()
      })

      this.bus.on('reset', function() {
        this.$refs.loginForm.reset()
      })
    }
  },
  props: {
    password: {
      type: String,
      default: undefined
    },
    username: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: 'primary'
    },
    solo: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledWhenNotValid: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    passwordError: {
      type: String,
      default: undefined
    },
    emailError: {
      type: String,
      default: undefined
    },
    disableEnterKey: {
      type: Boolean,
      default: false
    },
    loginButtonAlignment: {
      type: String,
      default: 'center',
      validator: function (value) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      }
    },
    loginButtonOutlined: {
      type: Boolean,
      default: false
    },
    loginButtonBlock: {
      type: Boolean,
      default: false
    },
    loginButtonColor: {
      type: String,
      default: undefined
    },
    emailValidation: {
      type: Boolean,
      default: false
    },
    createAccountButton: {
      type: Boolean,
      default: false
    },
    usernameLabel: {
      type: String,
      default: 'Username'
    },
    passwordLabel: {
      type: String,
      default: 'Password'
    },
    styles: {
      type: Object,
      default: function() {
        return {
          'username': {},
          'password': {},
          'loginButton': {},
          'createAccountButton': {}
        }
      }
    },
    classes: {
      type: Object,
      default: function() {
        return {
          'username': {},
          'password': {},
          'loginButton': {},
          'createAccountButton': {}
        }
      }
    }
  },
  methods: {
    handleKeyDown(event) {
      if(event.key == 'Enter' && !this.disableEnterKey) {
        this.$emit('login-click', this.localUsername, this.localPassword)
      }
    }
  },
  watch: {
    password(newVal) {
      this.localPassword = newVal
    },
    username(newVal) {
      this.localUsername = newVal
    },
    localUsername(newVal) {
      this.emit('change', {
        username: this.localUsername,
        password: this.localPassword,
      })
    },
    localPassword(newVal) {
      this.emit('change', {
        username: this.localUsername,
        password: this.localPassword,
      })
    }
  }
}
</script>

<style>

</style>